module.exports = __webpack_public_path__ + "media/images/flags/CA-ee17c1f21fa13b424e83430cb8becdee.svg";